import { useT } from "@/lib/i18n";

const CDN = "https://www.bosquesuspendido.com/wp-content/uploads";

export type ServiceSubcategory = { name: string; desc: string };
export type Service = {
  slug: string;
  name: string;
  desc: string;
  imageUrl?: string;
  subcategories?: ServiceSubcategory[];
};

type RawSubcategory = { key: string; name: string; desc: string };
type RawService = {
  slug: string;
  name: string;
  desc: string;
  imageUrl?: string;
  subcategories?: RawSubcategory[];
};

const RAW_SERVICES: RawService[] = [
  {
    slug: "circuitos",
    name: "Circuitos de aventura en los árboles",
    desc: "Pasa de árbol a árbol por retos que te harán sentir como una ardilla. Contamos con 11 circuitos de diversa dificultad, en los que damos cabida a todos los públicos a partir de los 2 años.",
    imageUrl: `${CDN}/2021/08/24784962_1579603448771597_2266169615750365344_o-300x200-1.jpg`,
    subcategories: [
      { key: "iniciacion", name: "Circuitos de iniciación", desc: "4 circuitos de aprendizaje a baja altura para manejar los elementos de seguridad y vivir las primeras sensaciones." },
      { key: "baby", name: "Circuito Baby", desc: "Para los más peques. Línea de vida continua deslizante en circuito cerrado: aventura sin ningún riesgo." },
      { key: "verdes", name: "Circuitos Verdes", desc: "Baja dificultad (color verde, como en ski). 3 circuitos para que los niños vayan solos o en familia." },
      { key: "diversion", name: "Circuitos de Diversión", desc: "Mayor altura y exigencia física: amarillo, rojo y azul, con características similares." },
      { key: "deportivo", name: "Circuito Deportivo", desc: "Color negro, para los más aventureros. Más altura y complejidad; requiere haber pasado por un circuito previo." },
    ],
  },
  {
    slug: "tirolinas",
    name: "Circuito de tirolinas",
    desc: "El circuito de tirolinas en árboles más grande de España, con más de 1 km de recorrido enlazando una tirolina tras otra. Lo más parecido a volar entre las copas de los pinos centenarios.",
    imageUrl: `${CDN}/2021/08/24785266_1579693252095950_9181477085439841031_o-300x200-1.jpg`,
  },
  {
    slug: "salto-vacio",
    name: "Salto al vacío",
    desc: "La actividad más cargada de adrenalina. Escala hasta 10 metros, asómate al borde y… salta al vacío en caída libre controlada.",
    imageUrl: `${CDN}/2021/08/IMG-20190915-WA0035-e1629738547861-300x200.jpg`,
  },
  {
    slug: "lucha-arqueros",
    name: "Lucha de arqueros",
    desc: "Arcos, flechas especiales, máscaras, obstáculos, dianas, carreras, eliminados y recargas de vida. El juego más divertido y actual que encontrarás en nuestras instalaciones.",
    imageUrl: `${CDN}/2021/08/IMG_8813-1024x683-1.jpg`,
  },
  {
    slug: "paintball",
    name: "Paintball",
    desc: "Campos diseñados para disfrutar al máximo de una batalla de bolas de pintura con tu familia, compañeros o amigos. Paintball Soft para toda la familia desde 8 años.",
    imageUrl: `${CDN}/2021/08/IMG-20190915-WA0034.jpg`,
  },
  {
    slug: "tiro-arco",
    name: "Tiro con arco",
    desc: "¿Tendrán Robin Hood o Guillermo Tell familiares en Sevilla? Emula sus épicos lanzamientos en nuestras zonas de tiro con arco.",
    imageUrl: `${CDN}/2021/08/IMG_3449-e1633528108166-1024x1013.jpg`,
  },
  {
    slug: "escalada",
    name: "Escalada en árbol",
    desc: "5 estaciones de escalada en árboles de distintas alturas y dificultad. Trepa, trepa, trepa… ¡Tarzán!",
    imageUrl: `${CDN}/2021/08/fullsizeoutput_424-300x222.jpg`,
  },
  {
    slug: "banana-jump",
    name: "Banana Jump",
    desc: "Si creías que el Salto al Vacío era emocionante, no has probado a saltar por nuestra Banana. Ármate de valor y trata de agarrarte. ¿Te atreves?",
    imageUrl: `${CDN}/2021/10/banana.jpg`,
  },
  {
    slug: "bosque-nocturno",
    name: "Bosque nocturno",
    desc: "Disfruta de nuestras actividades… a oscuras. Recorre el pinar después del atardecer con frontales y la magia del bosque de noche.",
    imageUrl: `${CDN}/2021/08/IMG_20190620_100039-1024x768.jpg`,
  },
  {
    slug: "gelball",
    name: "GelBall",
    desc: "La evolución del paintball: muchas más bolas a tu disposición, ritmo frenético y la misma diversión y seguridad.",
    imageUrl: `${CDN}/2024/11/gelBall-1.jpeg`,
  },
  {
    slug: "rocodromo",
    name: "Escalada en rocódromo",
    desc: "Escalada en estado puro con aseguradores automáticos o monitor. Nuestra torre dispone de escalera interior y plataforma superior para prácticas de rápel y progresión vertical.",
    imageUrl: `${CDN}/2024/11/IMG_7884-768x1024.jpeg`,
  },
  {
    slug: "boulder",
    name: "Boulder",
    desc: "24 m² de pared donde hacer todo tipo de juegos y dinámicas de escalada guiados por nuestro personal.",
    imageUrl: `${CDN}/2024/11/IMG_3915-768x1024.jpeg`,
  },
  {
    slug: "team-building",
    name: "Team Building",
    desc: "Amplio catálogo de actividades y dinámicas para trabajar las capacidades de tu equipo. Consúltanos para diseñar la jornada perfecta.",
    imageUrl: `${CDN}/2024/11/1655703947510-1024x512.jpg`,
  },
];

export function useServicesList(): Service[] {
  const { tk } = useT();
  return RAW_SERVICES.map((s) => ({
    slug: s.slug,
    name: tk(`services.${s.slug}.name`, s.name),
    desc: tk(`services.${s.slug}.desc`, s.desc),
    imageUrl: s.imageUrl,
    subcategories: s.subcategories?.map((sub) => ({
      name: tk(`services.${s.slug}.sub.${sub.key}.name`, sub.name),
      desc: tk(`services.${s.slug}.sub.${sub.key}.desc`, sub.desc),
    })),
  }));
}

export function getServicesListEs(): Service[] {
  return RAW_SERVICES.map((s) => ({
    slug: s.slug,
    name: s.name,
    desc: s.desc,
    imageUrl: s.imageUrl,
    subcategories: s.subcategories?.map(({ name, desc }) => ({ name, desc })),
  }));
}
